import { AutoMap } from "@automapper/classes";
import { Client } from "./client";
import { EUserType } from "./enum/user-type";

export class User {
    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }

    @AutoMap()
    Email: string = '';
    @AutoMap()
    FirstName: string = '';
    @AutoMap()
    LastName: string = '';
    @AutoMap()
    EIMASGuid: string = '';
    @AutoMap()
    IsActive: boolean = true;
    //#region EIMAS
    @AutoMap()
    PI_SRI: string = '';
    //#endregion

    /**
     * employee or customer
     */
    @AutoMap()
    Type: EUserType = EUserType.Standard;
    @AutoMap(() => [Client])
    ClientList: Client[] = [];

    // static mapFromJSON(json: any) {
    //     const m = new User();

    //     m.FirstName = json['firstName'];
    //     m.LastName = json['lastName'];
    //     m.Email = json['email'];
    //     m.Type = json['type'];
    //     m.EIMASGuid = json['eimasGuid'];
    //     m.IsActive = json['isActive'];
    //     if (json['clientList']) {
    //         m.ClientList = json['clientList'].map((item: any) => Client.mapFromJSON(item));
    //     }

    //     return m;
    // }
}
